document.addEventListener("change", (event) => {
  const input = event.target.closest("[data-document-input]");
  if (!input) return;

  const label = input.closest(".relation-document-picker")?.querySelector("[data-document-selection]");
  if (!label) return;

  const names = Array.from(input.files).map((file) => file.name);
  label.textContent = names.length ? names.join(", ") : "Geen nieuw bestand geselecteerd";
});
